import type React from "react";

import { Journal } from "../components/Journal";

export const MedicalRecord: React.FC = () => {
  return (
    <div data-testid="medical-record">
      <Journal />
    </div>
  );
};
